import tw from '../../tailwind.config';
import IconCheck from 'components/IconCheck';
import visualizer, { HexCode } from '@root/src/partials/visualizer';

interface FilterProps {
  filterColor?: string;
  filterLabel?: string;
  isActive?: boolean;
}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & FilterProps>;

const Filter: Props = ({ filterColor = 'transparent', filterLabel = 'Filter', isActive = false, ...props }) => {
  const effectiveColor: string | HexCode =
    filterColor !== 'transparent'
      ? visualizer.isColorFilter(filterColor)
        ? visualizer.getHexCodeForFilter(filterColor)
        : filterColor
      : tw.theme.colors.gray.light;

  return (
    <div
      className={`
        relative z-0 inline-flex cursor-pointer items-center 
        tracker-filter-${filterLabel}-20190611-145632 group
      `}
      title={filterLabel}
      {...props}
    >
      <div
        style={{
          backgroundColor: isActive ? tw.theme.colors.white : effectiveColor,
          borderColor: effectiveColor,
        }}
        className="
          relative z-20 flex h-0 w-0 items-center justify-center overflow-hidden border-1 p-[12px] text-center transition duration-150 ease-in-out
        "
      >
        <IconCheck
          className={`
          absolute transform transition duration-200 ease-in-out
          ${isActive ? 'translate-x-0 opacity-100' : '-translate-x-32 opacity-0'}
        `}
          color="grayDarker"
        />
      </div>

      <p className="max-w-full pl-8 text-xs leading-tight text-gray-darker group-hover:text-blue-dark">{filterLabel}</p>
    </div>
  );
};

Filter.displayName = 'Filter';

export default Filter;
